<template>
	<div class="main">
		<div class="search_con">
			<div class="search_left">
				<div class="search_left_title">分类：</div>
				<div :class="activeIndex == 0 ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(0)">全部</div>
				<div :class="activeIndex == 1 ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(1)">通知公告</div>
				<div :class="activeIndex == 2 ? 'search_left_active' : 'search_left_normal'" @click="chooseIndex(2)">政策法规</div>
			</div>
			<div class="search_right">
				<el-input
					class="search_input"
				  placeholder="请输入要搜索的内容"
				  v-model="input"
					size="small"
				  clearable>
				</el-input>
				<div class="search_btn" @click="gosearch">
					搜索
				</div>
			</div>
		</div>
		<div class="content_con">
			<div class="con_body">
				<div class="con_body_div">
					<template v-for="(item,key) in contentList">
						<div class="item_div" @click="goDetail(item)">
							<div class="item_top">
								<img class="item_img" v-if="item.link" :src="item.link" />
								<img v-else class="item_img" src="../assets/home/default.png" />
							</div>
							<div class="item_title">
								{{item.title}}
							</div>
							<div class="item_down">
								<div>作者：{{item.createName}}</div>
								<div>浏览次数：{{item.readCount}}</div>
							</div>
							<div class="item_time">发布时间：{{item.releaseTime | subStringTime}}</div>
						</div>
					</template>
				</div>
				<div class="pageCon">
					<el-pagination
						background
						class="mt-4"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="pageNo"
						:page-sizes="[12, 24, 32, 40]"
						:page-size="pageSize"
						layout=" prev, pager, next, sizes, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Message } from 'element-ui';
	export default {
		name: "",
		data() {
			return {
				contentList:[],
				pageNo:1,
				pageSize:12,
				total:0,
				input: '',
				category: '',
				activeIndex: 0,
			};
		},
		filters: {
			subStringTime(str) {
				return str.substring(0, 10);
			}
		},
		components: {},
		mounted() {
			this.getList();
		},
		methods:{
			chooseIndex(index){
				this.activeIndex = index;
				if(index == 1){
					this.category = '2'
				}else if(index == 2){
					this.category = '3'
				}else{
					this.category = ''
				}
				this.getList();
			},
			//查询
			getList(){
				this.$get('/blade-desk/notice/user/list',{
					current: this.pageNo,
					size: this.pageSize,
					category: this.category, //类型
					title: this.input,
				})
				.then((res) => {
					console.log(res);
					if(res.code == '200'){
						this.contentList = res.data.records;
						this.total = res.data.total;
					}else{
						this.$message({
						  message: res.msg,
						});
					}
				})
			},
			goDetail(obj){
				let routeUrl = this.$router.resolve({
				     path:'/textDetail/textDetail',
				     query:{
				     	id: obj.id
				     }
				   });
				window.open(routeUrl.href, '_blank');
			},
			handleCurrentChange(val) {
			  this.pageNo = val;
			  this.getList();
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			gosearch(){
				this.pageNo = 1;
				this.getList();
			}
		}
	};
</script>

<style scoped>
	.main {
		background-color: #F0F6F9;padding-bottom: 0.3rem;
	}
	.search_con{
		width: 12rem;height: 0.93rem;background: #fff;display: flex;align-items: center;justify-content: space-between;margin: 0.4rem auto;
		box-shadow: 0 0 0.14rem 0 #134f9721;border-radius: 0.06rem;
	}
	.search_left{
		display: flex;align-items: center;margin-left: 0.3rem;
	}
	.search_left_title{
		color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.14rem;font-weight: 700;
	}
	.search_left_active{
		padding: 0.04rem 0.08rem;border-radius: 4px;background: #134f971a;color: #134F97;font-size: 0.14rem;
		font-family: Alibaba PuHuiTi;font-weight: 400;margin-left: 0.2rem;cursor: pointer;
	}
	.search_left_normal{
		padding: 0.04rem 0.08rem;font-size: 0.14rem;font-family: Alibaba PuHuiTi;font-weight: 400;color: #000000;margin-left: 0.2rem;cursor: pointer;
	}
	.search_right{
		display: flex;align-items: center;margin-right: 0.3rem;
	}
	.search_input{
		width:3.45rem;height:0.33rem;line-height: 0.33rem;background: #EEEEEE;
	}
	.search_input>>>.el-input__inner{
		height: 0.33rem !important;
	}
	.search_btn{
		width: 0.76rem;height: 0.33rem;border-radius: 0.04rem;background: #FCC106;color: #ffffff;font-size: 0.14rem;
		font-family: Alibaba PuHuiTi;font-weight: 400;display: flex;align-items: center;justify-content: center;
		margin-left: 0.08rem;cursor: pointer;
	}
	.content_con{
		background-color:#F0F6F9;
		display: flex;justify-content: center;
	}
	.con_body{
		width: 12.3rem;background: #F0F6F9;
	}
	.con_body_div{
		display: flex;flex-wrap: wrap;height: 8.53rem;overflow-y: auto;align-content: flex-start;
	}
	.marginR30{
		margin-right: 0.3rem;
	}
	.item_div{
		width: 2.77rem;height: 2.5rem;margin-bottom: 0.3rem;cursor: pointer;border-radius: 0.06rem;background: #ffffff;box-shadow: 0 0 0.14rem 0 #134f9721;margin: 0.15rem;
	}
	.item_top{
		width: 2.77rem;height: 1.44rem;margin-bottom: 0.08rem;border-radius: 0.06rem 0.06rem 0 0;
	}
	.item_img{
		width: 2.77rem;height: 1.44rem;border-radius: 0.06rem 0.06rem 0 0;
	}
	.item_title{
		color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.18rem;font-weight: 500;height: 0.45rem;width: 2.42rem;display: -webkit-box;
								-webkit-box-orient: vertical;
								overflow: hidden;
								-webkit-line-clamp: 2;padding: 0 0.1rem;margin-bottom: 0.08rem;
	}
	.item_down{
		width: 2.42rem;display: flex;align-items: center;justify-content: space-between;padding: 0 0.1rem;
		color: #cccccc;font-family: Alibaba PuHuiTi;font-weight: 400;font-size: 0.14rem;
	}
	.item_time{
		color: #cccccc;font-family: Alibaba PuHuiTi;font-weight: 400;font-size: 0.14rem;margin: 0.04rem 0.1rem;
	}
	.pageCon{
		display: flex;justify-content: flex-end;font-size: 0.14rem;
	}
</style>



// WEBPACK FOOTER //
// src/index/training.vue